import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { noop } from 'es-toolkit';
import { forwardRef, useEffect, useState, RefObject, ReactElement } from 'react';

import Pagination from '@/components/Pagination/hammer-pagination/Pagination';
import { useGetQueryParams } from '@/hooks/queryParams/useGetQueryParams';
import { OtherCategoryCard } from '@/pages/DiscoverCategories/components/DiscoverCategories/components/OtherCategories/OtherCategoryCard/OtherCategoryCard';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { fetchOtherCategoriesIfNeeded } from '@/redux/modules/otherCategories/otherCategories';
import {
    createOtherCategoriesByPageSelector,
    otherCategoriesTotalResultsSelector,
} from '@/redux/modules/otherCategories/otherCategories.selectors';

import { defaultOtherCategoriesOptions, defaultOtherCategoriesPageSize } from './constants/otherCategoriesConstants';

const OtherCategoriesInner = (_props: unknown, ref: RefObject<HTMLDivElement>): ReactElement => {
    const dispatch = useAppDispatch();
    const getQueryParams = useGetQueryParams();
    const { page = 1, pageSize = defaultOtherCategoriesPageSize } = getQueryParams({ parseNumbers: true });
    const [currentCategories, setCurrentCategories] = useState([]);
    const categories = useAppSelector(createOtherCategoriesByPageSelector(page, pageSize));
    const totalResults = useAppSelector(otherCategoriesTotalResultsSelector);

    useEffect(() => {
        dispatch(fetchOtherCategoriesIfNeeded(page, pageSize));
    }, [dispatch, page, pageSize]);

    useEffect(() => {
        if (categories) {
            setCurrentCategories(categories);
        }
    }, [categories]);

    return (
        <section className="ml-lg mt-md">
            <div
                className="h-[40px]"
                ref={ref}
            />
            <h2 className="mb-lg">
                <FormattedMessage id="discoverPage.otherCategories.title" />
            </h2>
            <Pagination
                onChange={noop}
                pageSizeOptions={defaultOtherCategoriesOptions}
                paginationFilter={{
                    page,
                    pageSize,
                    totalRecords: totalResults,
                }}
                restrictPagesTo={10}
                shouldModifyQueryParams
            >
                <div className="flex flex-wrap justify-between">
                    {currentCategories.map((category) => (
                        <OtherCategoryCard
                            category={category}
                            key={category.title}
                        />
                    ))}
                </div>
            </Pagination>
        </section>
    );
};

export const OtherCategories = forwardRef(OtherCategoriesInner);
